import { withAITracking } from "@microsoft/applicationinsights-react-js";
import { reactPlugin } from "app-insights";
import RootPage from "pages/RootPage";
import localisations from "../../shell/localisation";
import { Grid, Typography } from "@mui/material";
import { ProductTable } from "domains/products/components/product-table";
import { getFieldCompanyId } from "shell/services/fieldCompanyService";
import { useAuth0 } from "@auth0/auth0-react";
import ProductSearch from "domains/products/components/product-search/ProductSearch";
import { useCallback, useLayoutEffect, useState } from "react";
import { generatePath, useHistory } from "react-router-dom";
import RoutePaths from "../../routes/route-paths";

function ProductPage() {
    const {
        product: { heading, blurb },
    } = localisations.pages;
    const { user } = useAuth0();
    const [fields, setFields] = useState({} as any);
    const [loadTable, setLoadTable] = useState(false);
    const [loadData, setLoadData] = useState(false);
    const [productDetails, setProductDetails] = useState({} as any);
    
    const fieldCompanyId = getFieldCompanyId(user);
    const history = useHistory();

    const handleFieldChange = useCallback((newFields: any) => {
        setFields((x: any) => ({ ...x, ...newFields }))
        setLoadData(false)
    } 
    , [setFields]);

    const rowClickNavigation = (partitionId: guid) => {
        history.push(generatePath(RoutePaths.ShowPartition, { id: partitionId }));
    };

    const handleSearch = (productDetails: any) => {
        var isProductSelected = productDetails?.id !== undefined;
        if (isProductSelected) {
            setProductDetails({ "id": productDetails.id, "name": productDetails.sku })
        }
        setLoadData(isProductSelected);
    };

    useLayoutEffect(() => {
        //Clear search only for menu click
        if (history.location.pathname === RoutePaths.Product && history.action !== "POP") {
            localStorage.removeItem("searchProductDetails");
        }
        else {
            var productDetails = JSON.parse(localStorage.getItem("searchProductDetails") ?? JSON.stringify({}));
            handleSearch(productDetails);
        }
        setLoadTable(true);
    }, [history.location.pathname, history.action]);

    return (
        <RootPage header={heading}>
            <Grid container spacing={2}>
                <Grid item xs={12}>
                    <Typography variant="body1" gutterBottom>
                        {blurb}
                    </Typography>
                </Grid>
                <Grid item xs={12}>
                    {loadTable && <ProductSearch fieldCompanyId={fieldCompanyId} fields={fields} handleFieldChange={handleFieldChange} handleSearch={handleSearch}/>}
                </Grid>
                <Grid item xs={12}>
                    {(loadData 
                    || (productDetails?.id !== undefined && fields?.productDetails?.id !== undefined && productDetails?.id === fields?.productDetails?.id)) 
                    && <ProductTable fieldCompanyId={fieldCompanyId} productId={productDetails.id} productName={productDetails.name} onRowClick={rowClickNavigation} />}
                </Grid>
            </Grid>
        </RootPage>
    );
}

export default withAITracking(reactPlugin, ProductPage, "Product Page")